import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-order-statistics",
  "use": "icon-order-statistics-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-order-statistics\"><path d=\"M424 352h-224a24 24 0 0 0 0 48h224a24 24 0 0 0 0-48z m272 208h-496a24 24 0 0 0 0 48h496a24 24 0 0 0 0-48z m0 208h-496a24 24 0 0 0 0 48h496a24 24 0 0 0 0-48z\" /><path d=\"M832 504V896a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64h392a24 24 0 0 1 0 48H128a16 16 0 0 0-16 16v768a16 16 0 0 0 16 16h640a16 16 0 0 0 16-16V504a24 24 0 0 1 48 0zM766.72 64z\" /><path d=\"M784 224V64h-32a192 192 0 1 0 208 192v-32z m-16 192a160 160 0 0 1-16-319.2V256h176a160 160 0 0 1-160 160z\" fill=\"#fff\" /><path d=\"M848 64.96L832 64h-16v128h144a128 128 0 0 0-112-127.04zM848 160V97.44A96 96 0 0 1 922.4 160z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/order-statistics.svg
// module id = BJsL
// module chunks = 13